module.exports = __webpack_public_path__ + "media/images/geo-fill-fc53083e.svg";